import { useExcelExport } from '@app/hooks';
import { Namespace } from '@app/Dashboard/models';
import { exportNamespacesToExcel } from './utils/namespaceExcelExport';

interface NamespaceExportParams {
    namespaces: Namespace[];
    periodLabel: string;
}

const generateNamespaceExcel = ({ namespaces, periodLabel }: NamespaceExportParams) =>
    exportNamespacesToExcel(namespaces, periodLabel);

export const useNamespaceExport = () => {
    const { exportToExcel, exporting, exportError, clearExportError } =
        useExcelExport<NamespaceExportParams>(generateNamespaceExcel);

    return {
        exportNamespaces: (namespaces: Namespace[], periodLabel: string) =>
            exportToExcel({ namespaces, periodLabel }),
        exporting,
        exportError,
        clearExportError,
    };
};
